module.exports = __webpack_public_path__ + "media/images/logo-f30029353495b8fc283ac437e8e5929b.svg";